module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/125.e04f3d61.png";